import Link from 'next/link';  // Correct import for Next.js Link

import Logo from '@/app/ui-component/Logo';

const LogoSection = () => {

    return (
        <Link href={"#"} >
            
                <Logo />
            
        </Link>
    );
};

export default LogoSection;
